// The kinds of position the reader played their middlegame in (queens on or
// off, an open or closed centre, kings castled on opposite sides, the
// reader's king exposed, a bishop pair, the exchange). Like `blunder` it
// lives in the scan's facts (`GameFacts.middlegamePositions`), which the
// filter does not read: whoever applies the filter resolves it first into
// `ids` (the game store's `resolveFilter`). Unresolved, it matches no game.
// The Middlegame screen's "Positions you misplay" bars open the library with it.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { MIDDLEGAME_POSITIONS, type MiddlegamePosition } from '@chess/api-model';

const LABEL: Record<MiddlegamePosition, string> = {
  'queens-on': 'Queens on',
  'queens-off': 'Queens off',
  'open-centre': 'Open centre',
  'closed-centre': 'Closed centre',
  'opposite-castling': 'Opposite castling',
  'exposed-king': 'Your king exposed',
  'bishop-pair': 'Your bishop pair',
  'their-bishop-pair': 'Their bishop pair',
  'exchange-up': 'Exchange up',
  'exchange-down': 'Exchange down',
};

export const middlegamePosition: FilterCriterion<'middlegamePosition'> = {
  key: 'middlegamePosition',
  query: 'mg-position',
  many: true,
  parse: oneOf(MIDDLEGAME_POSITIONS),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 68.5,
    more: true,
    label: 'Middlegame position',
    options: MIDDLEGAME_POSITIONS.map((p) => [p, LABEL[p]] as [MiddlegamePosition, string]),
  },
};
